import { Property } from "@app/models/Property";
import { SpinnerService } from "@app/services/spinner.service";
import { Component, Inject } from "@angular/core";
import { Router } from "@angular/router";

/**
 * Created by req89873 on 10/13/16.
 * This page lobbies an embedded iFrame to achieve what it needs to. The iframe's source can be found PAY/digitalpayments
 */

@Component({
    selector: 'app-credit-card-add',
    template: require('./creditCardAdd.html')
})
export class CreditCardAddComponent {
    comingFromPayNow: boolean;
    propertyId: any;
    property: Property;
    $stateParams: any;

    constructor(
        @Inject(SpinnerService) private spinnerService: SpinnerService,
        @Inject(Router) private router: Router
    ) {

        if (this.router.getCurrentNavigation()) {
            this.$stateParams = this.router.getCurrentNavigation().extras.state;
        }

        this.spinnerService.showSpinner();
        if (this.$stateParams) {
            this.comingFromPayNow = this.$stateParams.comingFromPayNow || false
            this.propertyId = this.$stateParams.propertyId || null
            this.property = this.$stateParams.property || null
        }
    }

    onReturn() {
        if (this.comingFromPayNow) {
            this.router.navigateByUrl('/properties/' + this.propertyId + '/payment' ,
                { state: { propertyId: this.propertyId, property: this.property } })
        } else {
            this.router.navigateByUrl('/wallet');
        }
    }

    onReady() {
        this.spinnerService.closeSpinner()
    }

}

